import * as React from 'react';
import { ArticleHeading1, ArticleParagraph1 } from '@cian/ui-kit';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

import * as styles from './styles.css';
import { trackAddressForm, VIEWED_TIMEOUT } from '../tracking';

interface IAddNewCardProps extends React.PropsWithChildren {
  containerRef?: React.Ref<HTMLDivElement>;
  annotation: React.ReactNode;
}

export const AddNewCardLayout: React.FC<IAddNewCardProps> = ({ containerRef, annotation, children }) => {
  return (
    <ActionAfterViewObserver callbackDelay={VIEWED_TIMEOUT} callback={trackAddressForm}>
      <div className={styles['container']} ref={containerRef}>
        <div className={styles['content']}>
          <div className={styles['titles']}>
            <ArticleHeading1 as="h1">
              Мой дом — центр управления
              <br />
              вашей недвижимостью
            </ArticleHeading1>

            <ArticleParagraph1>
              Добавляйте квартиры, дома и участки — расскажем всё, что нужно для выгодной продажи, сдачи и поиска нового
              жилья
            </ArticleParagraph1>
          </div>

          <div>{children}</div>
        </div>

        {annotation}
      </div>
    </ActionAfterViewObserver>
  );
};
